import { ColourInput, RawInput } from '@payaca/ambrosia';
import FieldLabel from '@payaca/components/fieldLabel/FieldLabel';
import { FC, type JSX } from 'react';

import './ColourPickerField.sass';

type Props = {
  colour?: string;
  description?: string;
  label?: string;
  isRequired?: boolean;
  onColourChange: (hex: string) => void;
};

const ColourPickerField: FC<Props> = ({
  colour = '#ffffff',
  description,
  isRequired = false,
  label,
  onColourChange,
}: Props): JSX.Element => {
  return (
    <div className="colour-picker-field">
      {label && (
        <FieldLabel
          label={label}
          isRequired={isRequired}
          description={description}
        />
      )}
      <div className="flex space-x-3.5 colour-picker-wrapper">
        <ColourInput value={colour} onChange={onColourChange} />
        <RawInput
          value={colour}
          onChange={(e) => onColourChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default ColourPickerField;
